import React from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';
import { User } from '../models/User';

interface LayoutProps {
  user: User;
  onLogout: () => void;
}

const Layout: React.FC<LayoutProps> = ({ user, onLogout }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader user={user} currentPage={window.location.pathname} onLogout={onLogout} />
      <Outlet />
    </div>
  );
};

export default Layout; 